export const masthead = () => {
    const advanceArrow = document.querySelector('.masthead--advance-arrow');
    if (advanceArrow) {
        advanceArrow.addEventListener('click', function(e) {
            e.preventDefault();
            const masthead = this.closest('.masthead');
            const nextGroup = masthead.nextElementSibling;
            if (nextGroup && nextGroup.classList.contains('wp-block-group')) {
                const elOffsetTop = nextGroup.offsetTop;
                window.scrollTo({
                    top: elOffsetTop,
                    behavior: 'smooth'
                });
            }
        });
    }

    const select = document.getElementById('assets--select-dropdown');
    const navValue = document.querySelector('.assets--value-number');
    const navDate = document.querySelector('.assets--as-of');

    if (select && navValue && navDate) {
        select.addEventListener('change', function() {
            const selectedClass = this.value;
            
            // Show loading state
            navValue.innerHTML = '';
            navValue.style.display = 'block';
            navDate.textContent = '';

            // Make AJAX request
            const formData = new FormData();
            formData.append('action', 'tpg_get_latest_nav');
            formData.append('nonce', localized_object.nonce);
            formData.append('class', selectedClass);

            fetch(localized_object.ajax_url, {
                method: 'POST',
                credentials: 'same-origin',
                body: formData
            })
            .then(response => response.json())
            .then(data => {
                if (data.success && data.data.nav) {
                    navValue.innerHTML = `<span class="assets--value-number-prefix">$</span>${data.data.nav}`;
                    navValue.style.display = 'block';
                    navDate.innerHTML = `as of ${data.data.date}`;
                } else {
                    navValue.style.display = 'none';
                    navDate.textContent = 'No data available';
                }
            })
            .catch(error => {
                console.error('Error:', error);
                navValue.style.display = 'none';
                navDate.textContent = 'No data available';
            });
        });
    }
}
  